import { Component, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { Location } from '@angular/common';
import { ApiUrls } from '../../apiRouts';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { ToasterServiceService } from '../../service/toaster.service';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrl: './contact-list.component.scss'
})
export class ContactListComponent implements OnInit {
  contactUsList: any;
  openContactUsList: any;
  closeContactUsList: any;
  selectedTabIndex: number = 0;

  constructor(
    private toasterService: ToasterServiceService,
    private location: Location,
    private mainService: MainService,
    private dialog: MatDialog,) { }

  goBackToPrevPage() {
    this.location.back();
  }

  ngOnInit() {
    this.getContactList();
  }

  onTabChanged(event: number) {
    this.selectedTabIndex == 0 ? this.getContactList() : this.getContactList();
  }

  getContactList() {
    this.mainService.getApi(ApiUrls.contactUsList).subscribe((res: any) => {
      if (res.status == 1) {
        this.contactUsList = res.constctUs;
        this.openContactUsList = this.contactUsList.filter((a: any) => a.is_active == 1);
        this.closeContactUsList = this.contactUsList.filter((a: any) => a.is_active == 0);
      }
    });
  }

  openDialog(e: any, data: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.statusChange(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  statusChange(member: any) {
    let data = {
      contact_us_id: Number(member.contact_us_id),
      person_name: '',
      contact_number: '',
      description: '',
      is_active: 0,
      Action: 'STATUS'
    };
    debugger
    this.mainService.postApi(ApiUrls.statusChange, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getContactList();
      } else {
        this.toasterService.toastError(res.response);
      }
    });
  }

}
